export enum ReportTableActionTypes {
  GoToContent = 'GO_TO_CONTENT',
  GoToContentUrl = 'GO_TO_CONTENT_URL',
  ViewProfile = 'VIEW_PROFILE',
  ViewUserProfile = 'VIEW_USER_PROFILE',
  GoToSession = 'GO_TO_SESSION',
  ViewMgsa = 'VIEW_MGSA',
  EditMgsa = 'EDIT_MGSA',
  CreateMgsa = 'CREATE_MGSA',
}

export type ReportTableAction = {
  type: ReportTableActionTypes;
  payload: { row?: any };
};
